import { NotesInput } from "./notes-input";
import React from "react";
import "styled-components/macro";

export function SuspendFormContent({
  formState,
  formActions,
  activeField,
  setActiveField
}) {
  return (
    <>
      <NotesInput
        value={formState.notes}
        onValueChange={formActions.setNotes}
        activeField={activeField}
        setActiveField={setActiveField}
        height={"200px"}
      />
    </>
  );
}
